<template lang="pug">
div
  el-card(shadow='hover').card-collapse
    app-header-dados-processo(
      :processo="processo",
      :isCCR="isCCR"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").card-container
    div
      el-steps.card-container(:active='active', finish-status='success', simple)
        el-step(title='Informar dados do VTN')
        el-step(title='Confirmar dados VTN')

      validation-observer(ref='validation' tag='div', v-if="active === 0")
        div(v-if="active === 0")
          InformarDadosRR( v-if="isRoraima"
            :vtnRequest="vtnRequest",
            :municipios="municipiosRR",
            @calculaModuloFiscal="calculaModuloFiscal"
          )
      div(v-if="active === 1")
        ConfirmarDados( v-if="!isRoraima"
          :dadosVtn="dadosVtn"
        )
        ConfirmarDadosRR( v-if="isRoraima"
          :dadosVtn="dadosVtn",
          :cadastro = "json"
        )

      app-buttons-cadastro(
        :showButtonCancelar='true',
        :showButtonProximo='!isUltimoPasso'
        :isUltimoPasso="isUltimoPasso",
        :isPrimeiroPasso="isPrimeiroPasso",
        @proximo="proximo",
        @voltar="voltar",
        @cancelar='cancelar',
        @finalizar='finalizar'
      )
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmarDados from './components/ConfirmarDados.vue'
import ConfirmarDadosRR from './components/ConfirmarDadosRR.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import InformarDados from './components/InformarDados.vue'
import InformarDadosRR from './components/InformarDadosRR.vue'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppHeaderDadosProcesso,
    InformarDados,
    AppButtonsCadastro,
    ConfirmarDados,
    ConfirmarDadosRR,
    InformarDadosRR
  },

  props: {
    processo: {
      type: Object,
      required: true
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      active: 0,
      isCCR: false,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      vtnRequest: {
        // dados de RR
        areaTotalImovelGeorreferenciado: '',
        gleba: '',
        tempoOcupacao: '',
        distanciaBoaVista: '',
        condutaLesivaMeioAmbiente: false,
        // dados do AP e comuns à ambos
        areaRequerida: '',
        moduloFiscal: '',
        nModuloFiscal: '',
        percentualAplicado: '',
        valorFinalImovel: '',
        tipoEletrificacao: '',
        municipio: {
          id: '',
          nome: ''
        }
      },
      municipiosRR: [],
      dadosVtn: {},
      dadosCadastro: '',
      json: {}
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.active === 0
    },
    isUltimoPasso () {
      return this.active === 1
    },
    isRoraima () {
      return process.env.ESTADO === 'rr'
    }
  },

  async created () {
    const processo = await this.getProcesso(this.processo.numeroProtocolo)
    this.dadosCadastro = await this.getDadosCadastroById(this.processo.id)
    this.dadosVtn = await this.getVtnByIdProcesso(processo.id)
    let municipio = this.dadosCadastro?.dados?.cadastro?.imovel?.municipio || processo.municipios[0]
    this.municipiosRR = await this.getMunicipios(process.env.ESTADO)
    const moduloFiscalMunicipio = this.calculaModuloFiscal(municipio?.id)
    if (municipio) {
      municipio = this.municipiosRR.find(m => m.id === municipio.id)
    }

    if (this.dadosVtn) {
      this.vtnRequest = {
        ...this.vtnRequest,
        gleba: this.dadosVtn.gleba,
        tempoOcupacao: this.dadosVtn.tempoOcupacao,
        areaTotalImovelGeorreferenciado: this.dadosVtn.areaTotalImovelGeorreferenciado,
        distanciaBoaVista: this.dadosVtn.distanciaBoaVista,
        id: this.dadosVtn.id,
        idProcesso: processo.id,
        processo: {
          id: processo.id
        },
        areaRequerida: this.dadosVtn?.areaRequerida,
        percentualAplicado: this.dadosVtn?.percentualAplicado,
        valorFinalImovel: this.dadosVtn?.valorFinalImovel,
        tipoEletrificacao: this.dadosVtn?.tipoEletrificacao,
        isRodoviaVicinais: processo?.dadosCadastro?.dados?.cadastro?.imovel?.isRodoviaVicinais || false
      }
    } else {
      const cadastro = JSON.parse(this.dadosCadastro)
      this.vtnRequest = {
        ...this.vtnRequest,
        areaTotalImovelGeorreferenciado: cadastro?.dados?.cadastro?.imovel?.area,
        idProcesso: processo.id,
        processo: {
          id: processo.id
        },
        gleba: '',
        areaRequerida: processo?.dadosCadastro?.dados?.cadastro?.qualificacao?.area,
        qtdModuloFiscal: moduloFiscalMunicipio || 0,
        percentualAplicado: '',
        valorFinalImovel: '',
        moduloFiscal: municipio?.municipio?.mf,
        municipio: municipio,
        tipoEletrificacao: processo?.dadosCadastro?.dados?.cadastro?.imovel?.tipoEletrificacao || '',
        isRodoviaVicinais: processo?.dadosCadastro?.dados?.cadastro?.imovel?.isRodoviaVicinais || false
      }
    }
    this.getDadosCadastro()
    if (municipio) {
      this.calculaModuloFiscal(municipio.id)
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo',
      createVtn: 'vtn/createVtn',
      updateVtn: 'vtn/updateVtn',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      finalizarVTNRR: 'vtn/finalizarVTNRR',
      getMunicipios: 'municipiosPortal/findMunicipiosPorEstado',
      getDadosCadastroById: 'processo/getDadosCadastroById'
    }),
    finalizar () {
      const tipoCadastro = JSON.parse(this.dadosCadastro)
      const mensagem = tipoCadastro.tipo !== 'NAO_ONEROSO' ? 'EXTERNO' : 'DRF'
      this.finalizarVTNRR(this.vtnRequest.processo.id)
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.PROCESSOS_ENCAMINHADOS.replace('$$', mensagem)
      )
      this.goToListagem()
    },
    cancelar () {
      this.$router.back()
    },
    goToListagem () {
      this.$router.push({
        name: 'CAIXA_ENTRADA'
      })
    },
    async proximo () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.VALIDATION_FAIL)
        return
      }
      const processo = await this.getProcesso(this.processo.numeroProtocolo)
      if (!this.dadosVtn.id) {
        this.dadosVtn = await this.createVtn(this.vtnRequest)
        this.dadosVtn.processo = {
          id: processo.id,
          numeroProcesso: processo.numeroProcesso,
          municipio: processo.municipios[0]
        }
        this.dadosVtn.condutaLesivaMeioAmbiente = this.vtnRequest?.condutaLesivaMeioAmbiente
        this.dadosVtn.distanciaBoaVista = this.vtnRequest.distanciaBoaVista
        this.dadosVtn.tempoOcupacao = this.vtnRequest.tempoOcupacao
        this.vtnRequest.id = this.dadosVtn.id
      } else {
        this.vtnRequest.id = this.dadosVtn.id
        this.getDadosCadastro()
        this.dadosVtn = await this.updateVtn(this.vtnRequest)
        this.dadosVtn.processo = {
          id: processo.id,
          numeroProcesso: processo.numeroProcesso,
          municipio: processo.municipios[0]
        }
        this.dadosVtn.condutaLesivaMeioAmbiente = this.vtnRequest?.condutaLesivaMeioAmbiente
        this.dadosVtn.distanciaBoaVista = this.vtnRequest.distanciaBoaVista
        this.dadosVtn.tempoOcupacao = this.vtnRequest.tempoOcupacao
        this.dadosVtn.percentualAplicado = this.vtnRequest?.percentualAplicadoFormatado
        this.dadosVtn.valorFinalImovel = this.vtnRequest?.valorFinalImovelFormatado
      }
      this.active = this.active + 1
    },
    voltar () {
      this.active = this.active - 1
    },
    getDadosCadastro () {
      this.json = JSON.parse(this.dadosCadastro)
      this.areaRequerida = this.json.dados.cadastro.imovel.area
      this.vtnRequest.areaCerrado = this.json.dados.cadastro.imovel.areaCerrado
      this.vtnRequest.areaFloresta = this.json.dados.cadastro.imovel.areaFloresta
      this.vtnRequest.areaReservaLegalCerrado = this.contemValorNumerico(this.json.dados.cadastro.imovel.areaReservaLegalCerrado) ? this.json.dados.cadastro.imovel.areaReservaLegalCerrado : 0.0
      this.vtnRequest.areaReservaLegalFloresta = this.contemValorNumerico(this.json.dados.cadastro.imovel.areaReservaLegalFloresta) ? this.json.dados.cadastro.imovel.areaReservaLegalFloresta : 0.0
      this.vtnRequest.possuiEletrificacao = this.json.dados.cadastro.imovel.possuiEletrificacao
      this.vtnRequest.possuiAcessoRodovia = this.json.dados.cadastro.imovel.possuiAcessoRodovia
      this.vtnRequest.possuiProjetoRecuperacao = this.json.dados.cadastro.imovel.possuiProjetoRecuperacao
      this.vtnRequest.possuiInteresseEcologico = this.json.dados.cadastro.imovel.possuiInteresseEcologico
      this.vtnRequest.isRecuperacaoAreaDegradada = this.json.dados.cadastro.imovel.isRecuperacaoAreaDegradada
      this.vtnRequest.isRodoviaPavimentada = this.json.dados.cadastro.imovel.isRodoviaPavimentada
      this.vtnRequest.isRodoviaVicinais = this.json?.dados?.cadastro?.imovel?.isRodoviaVicinais || false
    },
    contemValorNumerico (str) {
      return /[0-9]/.test(str)
    },
    async calculaModuloFiscal (value) {
      const municipio = this.municipiosRR?.find(m => m.id === value)
      this.vtnRequest.qtdModuloFiscal = Math.ceil(this.vtnRequest.areaTotalImovelGeorreferenciado / municipio.mf)
      this.vtnRequest.moduloFiscal = municipio.mf
      this.vtnRequest.municipio = municipio
    }
  }
}
</script>

<style lang="scss" scoped>
.card-collapse {
  border-radius: 10px;
  margin: 20px;
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/CadastrarVtnRR.vue